import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@material-ui/core';
import { FC, useMemo, useState } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import {
  CONTESTATION,
  CONTESTATION_AGAINST,
  CONTESTATION_FIELDS,
  PROCEDURE_STATUSES,
} from 'containers/data-structure';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import { translate } from 'containers/services/translate';
import messages from 'containers/LawyerLegalProceedingsPage/messages';
import { StyledTitleTypography } from 'containers/LawyerLegalProceedingsPage/styled-components';
import VictimItem from 'components/VictimItem';
import { Container } from 'containers/LawyerLegalProceedingsPage/Contestation/styled-components';
import { StyledVictimsList } from 'containers/LawyerLegalProceedingsPage/Contestation/style';
import { get, isEmpty, isNil } from 'lodash';
import { Listings } from 'containers/AppContainer/typings';
import PrimaryButton from 'components/Buttons/PrimaryButton';
import { BUTTON_COLORS } from 'constants/design';
import { Autocomplete, AutocompleteChangeReason } from '@material-ui/lab';
import {
  AUTO_COMPLETE_CLEAR_OPTION,
  AUTO_COMPLETE_REMOVE_OPTION,
  AUTO_COMPLETE_SELECT_OPTION,
} from 'containers/CourtManagerLegalProceedings/Provision/constants';
import { STATUS_REJECTED } from 'containers/LawyerFeeNote/constants';
import {
  CONTESTATION_AGAINST_TYPE,
  WITHDRAWAL_CONTESTATION_TYPE,
} from 'containers/LawyerLegalProceedingsPage/Contestation/constants';
import { toast } from 'react-toastify';
import { PAGES } from 'routes';
import { pushTo } from 'containers/services/routes-helper';
import {
  filterVehicle,
  filterVictim,
} from 'containers/CourtManagerLegalProceedings/utils';
import { getVictimFromSagisInfo } from 'containers/PreOpeningPage/utils';
import userPrivileges, {
  PRIVILEGES,
} from 'containers/services/security/user-privileges';
export interface ContestationInfosProps {
  intl: IntlShape;
  contestation: any;
  isLawyer?: Boolean;
  disabled: boolean;
  listings: Listings;
  claim: any;
  judgementOnMerits: any;
  updateContestation: any;
  claimNumber?: string;
  sagisVictimInfo: any;
  isConsultation: boolean;
}

const ContestationInfos: FC<ContestationInfosProps> = props => {
  const { contestation } = props;
  const [updateForm, setUpdateForm] = useState({
    owner: contestation.owner,
    commentary: contestation.commentary,
    withdrawalReasonId: contestation.withdrawalReasonId,
    against: contestation.against,
    type: contestation.type,
    victims: contestation.victims,
    vehicules: contestation.vehicules,
    difficultyExecution: contestation.difficultyExecution,
    defenseExecution: contestation.defenseExecution,
  });
  const { victims = [], vehicules = [] } = contestation;
  const listVictims = () =>
    victims.map(({ firstName, lastName, victimKey }: any) => (
      <VictimItem
        firstName={
          featureService.hasFeature(FEATURES.MIGRATION_CLAIM_INFO)
            ? get(
                getVictimFromSagisInfo(victimKey, props.sagisVictimInfo),
                'victimFirstName',
                '',
              )
            : firstName
        }
        lastName={
          featureService.hasFeature(FEATURES.MIGRATION_CLAIM_INFO)
            ? get(
                getVictimFromSagisInfo(victimKey, props.sagisVictimInfo),
                'victimLastName',
                '',
              )
            : lastName
        }
      />
    ));
  const listVehicules = () =>
    vehicules.map(({ registrationNumber }: any) => (
      <VictimItem firstName={registrationNumber} lastName={''} />
    ));

  const handleFormChange = (
    event: React.ChangeEvent<{
      name?: string;
      value?: any;
    }>,
  ) => {
    const { name, value } = event.target;
    if (value === CONTESTATION_AGAINST.VEHICLE && name)
      return setUpdateForm(
        Object.assign(
          {},
          {
            ...updateForm,
            victims: get(updateForm, 'victims', []).map((item: any) => ({
              ...item,
              JudgementOnMeritsContestationVictim: {
                ...get(item, 'JudgementOnMeritsContestationVictim'),
                isDeleted: true,
              },
            })),
            [name]: value,
          },
        ),
      );
    if (value === CONTESTATION_AGAINST.VICTIM && name)
      return setUpdateForm(
        Object.assign(
          {},
          {
            ...updateForm,
            vehicules: get(updateForm, 'vehicules', []).map((item: any) => ({
              ...item,
              JudgementOnMeritsContestationVehicle: {
                ...get(item, 'JudgementOnMeritsContestationVehicle'),
                isDeleted: true,
              },
            })),
            [name]: value,
          },
        ),
      );
    if (name === CONTESTATION.TYPE && value !== get(withDrawalReason, 'id', ''))
      setUpdateForm(
        Object.assign(
          {},
          {
            ...updateForm,
            [CONTESTATION.WITHDRAWALREASON]: null,
          },
        ),
      );
    name && setUpdateForm(Object.assign({}, { ...updateForm, [name]: value }));
    if (name === CONTESTATION.DEFENSE_EXECUTION)
      setUpdateForm(
        Object.assign(
          {},
          {
            ...updateForm,
            [name]: !get(updateForm, CONTESTATION.DEFENSE_EXECUTION),
          },
        ),
      );
    if (name === CONTESTATION.DIFFICULTY_EXECUTION)
      setUpdateForm(
        Object.assign(
          {},
          {
            ...updateForm,
            [name]: !get(updateForm, CONTESTATION.DIFFICULTY_EXECUTION),
          },
        ),
      );
  };

  const handleItem = (type: string) => (
    event: React.ChangeEvent<{}>,
    value: any[],
    reason: AutocompleteChangeReason,
  ) => {
    const contestationType =
      type === CONTESTATION_AGAINST_TYPE.VICTIMS.ITEM
        ? CONTESTATION_AGAINST_TYPE.VICTIMS.CONTESTATION
        : CONTESTATION_AGAINST_TYPE.VEHICLES.CONTESTATION;
    const form = Object.assign({}, { ...updateForm });
    value.forEach(item => {
      const foundItem =
        get(form, type, []).find((el: any) => el.id === item.id) || {};

      isEmpty(foundItem) &&
        get(form, type, []).push({
          id: item.id,
          firstName: item.firstName,
          lastName: item.lastName,
          registrationNumber: item.registrationNumber,
          [contestationType]: {
            ...get(item, contestationType, {}),
            isDeleted: false,
          },
        });
    });
    get(form, type, []).forEach((item: any) => {
      const foundItem = value.find(el => el.id === item.id) || {};
      if (reason === AUTO_COMPLETE_REMOVE_OPTION && isEmpty(foundItem)) {
        get(form, type, [])[get(form, type, []).indexOf(item)] = {
          ...item,
          [contestationType]: {
            ...get(item, contestationType, {}),
            isDeleted: true,
          },
        };
      }
      if (reason === AUTO_COMPLETE_SELECT_OPTION && !isEmpty(foundItem)) {
        get(form, type, [])[get(form, type, []).indexOf(item)] = {
          ...item,
          [contestationType]: {
            ...get(item, contestationType, {}),
            isDeleted: false,
          },
        };
      }
      if (reason === AUTO_COMPLETE_CLEAR_OPTION)
        get(form, type, [])[get(form, type, []).indexOf(item)] = {
          ...item,
          [contestationType]: {
            ...get(item, contestationType, {}),
            isDeleted: true,
          },
        };
    });

    setUpdateForm(form);
  };
  const withDrawalReason = useMemo(
    () =>
      get(props.listings, 'judgementOnMeritsContestationTypes', []).find(
        item => item.title === WITHDRAWAL_CONTESTATION_TYPE,
      ) || {},
    [],
  );

  const handleSubmit = () => {
    props.updateContestation(
      props.judgementOnMerits?.jom?.jmc?.id,
      props.judgementOnMerits?.jom?.jmc?.hearingDate,
      get(contestation, 'lawyerOpinion'),
      props.judgementOnMerits?.claimId,
      props.judgementOnMerits?.procedureType,
      props.judgementOnMerits?.judiciaryProcessId,
      props.judgementOnMerits?.validator,
      props.isLawyer
        ? PROCEDURE_STATUSES.PENDING
        : props.judgementOnMerits?.jom?.jmc?.status,
      props.claimNumber,
      props.isLawyer || false,
      false,
      handleSuccessCallback,
      null,
      updateForm,
    );
  };

  const handleSuccessCallback = () => {
    toast.success(
      translate(messages.successContestationUpdateToastTitle, props),
    );
    if (
      !featureService.hasFeature(FEATURES.EVOLUTIONS_FEE_NOTE) &&
      !props.isLawyer
    ) {
      pushTo(PAGES.COURT_MANAGER_HOME)();
    } else {
      props.isLawyer && pushTo(PAGES.LAWYER_ASSIGNMENTS)();
    }
  };

  return (
    <Container className="subContainer">
      {contestation && (
        <>
          <Grid container spacing={3}>
            <Grid item xs={3}>
              <FormControl fullWidth>
                <InputLabel>
                  {translate(messages.lawyercontestationType, props)}
                </InputLabel>
                <Select
                  onChange={handleFormChange}
                  name={CONTESTATION_FIELDS.TYPE}
                  value={get(updateForm, [CONTESTATION_FIELDS.TYPE], '')}
                  disabled={props.disabled}
                >
                  {get(props.listings, 'judgementOnMeritsContestationTypes', [])
                    .filter(
                      (el: any) =>
                        (el.displayedFor ===
                          props.judgementOnMerits?.procedureType ||
                          isNil(el.displayedFor)) &&
                        el.isVisible,
                    )
                    .map((type: any) => (
                      <MenuItem value={type.id} key={type.id}>
                        {type.title}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={3}>
              <FormControl fullWidth>
                <InputLabel>
                  {translate(
                    messages.judgementOnMeritsContestationOwner,
                    props,
                  )}
                </InputLabel>
                <Select
                  onChange={handleFormChange}
                  name={CONTESTATION.OWNER}
                  value={get(updateForm, [CONTESTATION.OWNER], '')}
                  disabled={props.disabled}
                >
                  {get(
                    props.listings,
                    'judgementOnMeritsContestationOwners',
                    [],
                  ).map((type: any) => (
                    <MenuItem value={type.id} key={type.id}>
                      {type.title}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            {updateForm.type === get(withDrawalReason, 'id', '') && (
              <Grid item xs={3}>
                <FormControl fullWidth>
                  <InputLabel>
                    {translate(
                      messages.judgementOnMeritsContestationWithdrawalReason,
                      props,
                    )}
                  </InputLabel>
                  <Select
                    onChange={handleFormChange}
                    name={CONTESTATION_FIELDS.WITHDRAWAL_REASON}
                    id={CONTESTATION_FIELDS.WITHDRAWAL_REASON}
                    value={get(
                      updateForm,
                      [CONTESTATION_FIELDS.WITHDRAWAL_REASON],
                      '',
                    )}
                    disabled={props.disabled}
                  >
                    {get(
                      props.listings,
                      'judgementOnMeritsContestationWithdrawalReasons',
                      [],
                    ).map((type: any) => (
                      <MenuItem value={type.id} key={type.id}>
                        {type.title}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            )}
            <Grid item xs={3}>
              <FormControl fullWidth>
                <InputLabel>
                  {translate(messages.contestationAgainst, props)}
                </InputLabel>
                <Select
                  onChange={handleFormChange}
                  name={CONTESTATION_FIELDS.AGAINST}
                  value={Object.values(CONTESTATION_AGAINST).find(
                    item =>
                      item ===
                      get(updateForm, [CONTESTATION_FIELDS.AGAINST], ''),
                  )}
                  disabled={props.disabled}
                >
                  {Object.values(CONTESTATION_AGAINST).map(
                    (type: any, index) => (
                      <MenuItem value={type} key={index}>
                        {type}
                      </MenuItem>
                    ),
                  )}
                </Select>
              </FormControl>
            </Grid>
            {victims.length > 0 &&
              get(contestation, 'status') !== STATUS_REJECTED &&
              props.isLawyer && (
                <Grid item xs={5}>
                  <StyledTitleTypography className="input">
                    {translate(messages.contestationVictimes, props)}
                  </StyledTitleTypography>
                  <StyledVictimsList>{listVictims()}</StyledVictimsList>
                </Grid>
              )}

            {vehicules.length > 0 &&
              get(contestation, 'status') !== STATUS_REJECTED &&
              props.isLawyer && (
                <Grid item xs={5}>
                  <StyledTitleTypography className="input">
                    {translate(messages.contestationVehicules, props)}
                  </StyledTitleTypography>

                  <StyledVictimsList>{listVehicules()}</StyledVictimsList>
                </Grid>
              )}
            <Grid item xs={3}>
              <TextField
                fullWidth
                id="contestation_comment_field"
                label={translate(
                  messages.judgementOnMeritsCommentaryFieldTitle,
                  props,
                )}
                className="input"
                onChange={handleFormChange}
                name={CONTESTATION_FIELDS.COMMENT}
                value={updateForm.commentary}
                disabled={props.disabled}
              />
            </Grid>
            {((get(contestation, 'status') === STATUS_REJECTED &&
              props.isLawyer) ||
              userPrivileges.userHasPrivilege(PRIVILEGES.ISCOURTMANAGER)) &&
              updateForm.against === CONTESTATION_AGAINST.VICTIM && (
                <Grid item xs={5}>
                  <FormGroup className="content-item">
                    <article>
                      <h4 className="accordion-title">
                        {translate(messages.contestationVictimes, props)}
                      </h4>
                    </article>

                    <Autocomplete
                      id="victims"
                      className="auto-complete-item"
                      multiple
                      options={filterVictim(get(props.claim, 'victims', []))}
                      getOptionLabel={(option: any) =>
                        `${option.lastName} ${option.firstName}`
                      }
                      value={get(updateForm, 'victims', []).filter(
                        (item: any) =>
                          !get(
                            item,
                            'JudgementOnMeritsContestationVictim.isDeleted',
                            false,
                          ),
                      )}
                      onChange={handleItem(
                        CONTESTATION_AGAINST_TYPE.VICTIMS.ITEM,
                      )}
                      renderInput={params => (
                        <TextField {...params} variant="standard" />
                      )}
                    />
                  </FormGroup>
                </Grid>
              )}
            {((get(contestation, 'status') === STATUS_REJECTED &&
              props.isLawyer) ||
              (!props.isConsultation &&
                userPrivileges.userHasPrivilege(PRIVILEGES.ISCOURTMANAGER))) &&
              updateForm.against === CONTESTATION_AGAINST.VEHICLE && (
                <Grid item xs={5}>
                  <FormGroup className="content-item">
                    <article>
                      <h4 className="accordion-title">
                        {translate(messages.contestationVehicules, props)}
                      </h4>
                    </article>

                    <Autocomplete
                      id="vehicles"
                      className="auto-complete-item"
                      multiple
                      options={filterVehicle(get(props.claim, 'vehicules', []))}
                      getOptionLabel={(option: any) =>
                        option.registrationNumber
                      }
                      value={get(updateForm, 'vehicules', []).filter(
                        (item: any) =>
                          !get(
                            item,
                            'JudgementOnMeritsContestationVehicle.isDeleted',
                            false,
                          ),
                      )}
                      onChange={handleItem(
                        CONTESTATION_AGAINST_TYPE.VEHICLES.ITEM,
                      )}
                      renderInput={params => (
                        <TextField {...params} variant="standard" />
                      )}
                    />
                  </FormGroup>
                </Grid>
              )}
          </Grid>
          <div className="check-boxes">
            <FormControl className="formEl">
              <FormControlLabel
                control={
                  <Checkbox
                    checked={get(
                      updateForm,
                      CONTESTATION.DIFFICULTY_EXECUTION,
                      false,
                    )}
                    color="primary"
                    onChange={handleFormChange}
                  />
                }
                name={CONTESTATION.DIFFICULTY_EXECUTION}
                id={CONTESTATION.DIFFICULTY_EXECUTION}
                label={translate(
                  messages.judgementOnMeritsContestationDifficultyExecution,
                  props,
                )}
              />
            </FormControl>
            <FormControl>
              <FormControlLabel
                name={CONTESTATION.DEFENSE_EXECUTION}
                control={
                  <Checkbox
                    checked={get(
                      updateForm,
                      CONTESTATION.DEFENSE_EXECUTION,
                      false,
                    )}
                    color="primary"
                    onChange={handleFormChange}
                  />
                }
                label={translate(
                  messages.judgementOnMeritsContestationDefenseExecution,
                  props,
                )}
              />
            </FormControl>
          </div>
          {((get(contestation, 'status') === STATUS_REJECTED &&
            props.isLawyer) ||
            (!props.isConsultation &&
              userPrivileges.userHasPrivilege(PRIVILEGES.ISCOURTMANAGER))) && (
            <PrimaryButton
              className="validate-button"
              data-testid="validate"
              background={BUTTON_COLORS.PRIMARY_BLUE}
              border={BUTTON_COLORS.PRIMARY_BLUE}
              titlecolor={BUTTON_COLORS.BLUE_BUTTON_TITLE}
              title={translate(messages.validateButton, props)}
              onClick={handleSubmit}
              style={{ float: 'right' }}
            />
          )}
        </>
      )}
    </Container>
  );
};

export default injectIntl(ContestationInfos);
